export const MARK_TEXT_COLOR = 'markTextColor';
export const MARK_TEXT_SELECTION = 'markTextSelection';
